import type { FC } from 'react';
import React from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Box, CircularProgress, Dialog } from '@mui/material';

import { useTicketTableContext } from 'src/components/followUp/TicketFilterContext';
import ModalContentMain from 'src/components/followUp/TicketOverviewPage/TicketDetail/ModalContentMain';
import ModalHeader from 'src/components/followUp/TicketOverviewPage/TicketDetail/ModalHeader';
import ModalSidebar from 'src/components/followUp/TicketOverviewPage/TicketDetail/Sidebar/ModalSidebar';
import { useSurveyDetailQuery } from 'src/components/survey/SurveySettings/api';

import { styles } from 'src/components/followUp/TicketOverviewPage/TicketDetail/ticketDetail.styles';

const TicketDetailModal: FC = () => {
  const {
    selectedTicket: ticket,
    detailIsLoading,
    refreshTickets,
  } = useTicketTableContext();
  const { data: survey } = useSurveyDetailQuery();
  const history = useHistory();
  const selectedTicketId = new URLSearchParams(useLocation().search).get(
    'ticket',
  );
  return (
    <Dialog
      open={selectedTicketId !== null}
      onClose={() => history.replace({ search: '' })}
      maxWidth="xl"
      fullWidth
      sx={styles.modalRoot}
    >
      <ModalHeader />
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: 0,
          flexGrow: 1,
        }}
      >
        {ticket ? (
          <>
            <ModalContentMain
              ticket={ticket}
              survey={survey}
              refetchList={refreshTickets}
            />
            <ModalSidebar
              ticket={ticket}
              loading={detailIsLoading}
              refetchList={refreshTickets}
            />
          </>
        ) : (
          <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
export default TicketDetailModal;
